module.exports = __webpack_public_path__ + "static/media/01 Home.7a7567e7.png";